import {useEffect} from 'react';
import {useAutolog} from '@app/hooks/auth/useAutolog';
import {AuthStatus} from '@app/hooks/auth/useAutolog/utils';
import {useLogout} from '../useLogout';

/**
 * Controls the behavior and variables of the apps page
 * Is synced to user auth state to be able to bypass screens etc
 * @returns
 */
export const useAppsController = () => {
	const {status} = useAutolog(false);
	const {logout} = useLogout();

	useEffect(() => {
		if (status === AuthStatus.unlogged) {
			logout();
		}
	}, [logout, status]);

	return {
		isLoading: status === AuthStatus.loading || status === AuthStatus.unlogged,
	};
};
